function AddLiquidityPageHistoryIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8571 6.28571C12.8571 5.81233 12.4734 5.42857 12 5.42857C11.5266 5.42857 11.1429 5.81233 11.1429 6.28571V12C11.1429 12.2955 11.2951 12.5702 11.5457 12.7269L14.9743 14.8697C15.3757 15.1206 15.9045 14.9986 16.1554 14.5971C16.4063 14.1957 16.2843 13.6669 15.8829 13.416L12.8571 11.5249V6.28571Z"
        fill="#0088CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.71429 12C3.71429 7.42393 7.42393 3.71429 12 3.71429C16.5761 3.71429 20.2857 7.42393 20.2857 12C20.2857 16.5761 16.5761 20.2857 12 20.2857C7.42393 20.2857 3.71429 16.5761 3.71429 12Z"
        fill="#0088CC"
      />
    </svg>
  );
}

export default AddLiquidityPageHistoryIcon;
